import { QueryKey, UseQueryOptions } from 'react-query';
import { Title } from '../../titles/types/title';
import { Product, Purchase, Rental, SubscribedProduct } from '../products/types';
import {
  fetchProducts,
  fetchPurchases,
  fetchRentals,
  getPurchasedTitles,
  getRentedTitles,
  getSubscribedProducts,
  getSubscribedTitles,
} from './api';
import {
  productsKey,
  purchasedTitlesKey,
  purchasesKey,
  rentalsKey,
  rentedTitlesKey,
  subscribedProductsKey,
  subscribedTitlesKey,
} from './keys';

export function productsQuery<T = Product[]>(
  platformTitleId: string,
  options?: UseQueryOptions<Product[], unknown, T, QueryKey>,
) {
  return {
    queryKey: productsKey(platformTitleId),
    queryFn: () => fetchProducts(platformTitleId),
    ...options,
  } as const;
}

export function purchasesQuery<T = Purchase[]>(options?: UseQueryOptions<Purchase[], unknown, T, QueryKey>) {
  return {
    queryKey: purchasesKey(),
    queryFn: () => fetchPurchases(),
    ...options,
  } as const;
}

export function rentalsQuery<T = Rental[]>(options?: UseQueryOptions<Rental[], unknown, T, QueryKey>) {
  return {
    queryKey: rentalsKey(),
    queryFn: () => fetchRentals(),
    ...options,
  } as const;
}

export function subscribedProductsQuery<T = SubscribedProduct[]>(
  options?: UseQueryOptions<SubscribedProduct[], unknown, T, QueryKey>,
) {
  return {
    queryKey: subscribedProductsKey(),
    queryFn: () => getSubscribedProducts(),
    ...options,
  } as const;
}

export function purchasedTitlesQuery<T = Title[]>(options?: UseQueryOptions<Title[], unknown, T, QueryKey>) {
  return {
    queryKey: purchasedTitlesKey(),
    queryFn: () => getPurchasedTitles(),
    ...options,
  } as const;
}

export function rentedTitlesQuery<T = Title[]>(options?: UseQueryOptions<Title[], unknown, T, QueryKey>) {
  return {
    queryKey: rentedTitlesKey(),
    queryFn: () => getRentedTitles(),
    ...options,
  } as const;
}

export function subscribedTitlesQuery<T = Title[]>(options?: UseQueryOptions<Title[], unknown, T, QueryKey>) {
  return {
    queryKey: subscribedTitlesKey(),
    queryFn: () => getSubscribedTitles(),
    ...options,
  } as const;
}
